<app-loading></app-loading>
<app-toast></app-toast>
<div *ngIf="showHeader" class="d-flex flex-column">
    <app-header
        [isThirdParty]="isThirdParty"
        [isLandingPage]="isLandingPage"
        (navToggled)="isNavOpen = $event"
        (profileNavToggled)="isProfileNavOpen = $event"
        (themeChange)="onThemeChange($event)"
    ></app-header>

    <div>
        @if(isLandingPage){
        <div
            *ngIf="showBanner"
            class="warning-banner"
            [style.left.px]="isNavOpen ? 354 : 72"
            [style.right.px]="isProfileNavOpen ? 463 : showChatbot ? chatbotWidth : 0"
            [class.chatbot-open]="showChatbot"
        >
            <mat-icon [svgIcon]="'exclamation-circle'" alt="Warning"></mat-icon>
            <span
                >The following records cannot be accessed via Policy 360:<span class="banner-text">
                    Motorcycle policies, Personal Liability policies, Legacy AS400 policies</span
                >
                and <span class="banner-text">quotes</span>. Use the original source systems to view them.</span
            >
            <mat-icon [svgIcon]="'close-alt'" alt="close" (click)="dismissBanner()"></mat-icon>
        </div>
        <div
            class="landing-page d-flex flex-column psic-gap-8"
            [class.chatbot-open]="showChatbot"
            [style.left.px]="isNavOpen ? 354 : 72"
            [style.right.px]="showChatbot ? chatbotWidth : 0"
            [style.top]="showBanner ? 'calc(60px + 48px)' : '60px'"
            [style.height]="showBanner ? 'calc(100vh - 60px - 48px)' : 'calc(100vh - 60px)'"
        >
            <div id="User authenticated">
                <app-user-authenticated
                    [class.highlighted]="highlightedSection === 'user authenticated'"
                ></app-user-authenticated>
            </div>

            <div id="ivr-profile-card">
                <app-ivr-profile-card></app-ivr-profile-card>
            </div>
            <div id="best-match-card">
                <app-best-match-component></app-best-match-component>
            </div>
        </div>
        }

        <div>
            <app-chatbot-widget
                *ngIf="showChatbot && showChatWidget"
                (closeChatbot)="onChatbotClose()"
                [sessionId]="sessionId"
                [isLandingPage]="false"
                [contactId]="contactId"
                [channel]="channel"
                [attributes]="attributes"
                class="chatbot-widget"
            ></app-chatbot-widget>

            <mat-icon
                svgIcon="ai-chat-icon"
                class="mat-icon-64 floating-chat-btn"
                (click)="openChatbot()"
                *ngIf="!showChatbot && showChatWidget"
            ></mat-icon>
        </div>
    </div>
</div>
<div [class.nav-open]="isNavOpen" [class.chatbot-open]="showChatbot" class="page-content">
    <router-outlet></router-outlet>
</div>
